import styled from '@emotion/styled';

const HamburgerLine = styled.span`
  width: 40px;
  height: 4px;
  background-color: white;
  display: block;
  margin: 9px auto;
  transition: transform 0.3s ease-in-out;
`;

export { HamburgerLine as default };
